<template>
    <div>
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.exchange_rates_page_title')" />
        <v-tabs v-model="selectedTab">
            <v-tab v-for="tab in tabs" :key="tab.value + '-tab'">
                {{ tab.title }}
            </v-tab>
        </v-tabs>
        <v-window v-model="selectedTab">
            <v-window-item value="rates">
                <ExchangeRatesTable class="pa-4" />
            </v-window-item>
            <v-window-item value="edit">
                <ManualExchangeRatesTable class="pa-4" />
            </v-window-item>
            <v-window-item value="history">
                <ExchangeRatesHistoryTable class="pa-4" />
            </v-window-item>
        </v-window>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import ExchangeRatesTable from '@/components/account/exchangeRates/ExchangeRatesTable.vue'
    import ExchangeRatesHistoryTable from '@/components/account/exchangeRates/ExchangeRatesHistoryTable.vue'
    import ManualExchangeRatesTable from '@/components/account/exchangeRates/ManualExchangeRatesTable.vue'
    import PageTitle from '@/components/parts/PageTitle.vue'

    const {t} = useI18n()
    const conf = useRuntimeConfig()

    const tabs: ComputedRef<{title: string; value: string}[]> = computed(() => {
        const tabs: {title: string; value: string}[] = [{title: t('rates'), value: 'rates'}]

        if (conf.public.account.showExchangeRatesEdit) tabs.push({title: t('edit_rates'), value: 'edit'})

        tabs.push({title: t('history'), value: 'history'})

        return tabs
    })

    const selectedTab = ref<number>(0)
</script>
